/* eslint-disable */
import { useState } from 'react';

export default function PhonebookBox({ event, setNodes, setRefecther, refecther, phonebookQuery }) {
    const [refresher, setRefresher] = useState(false);
    const phonebookData = phonebookQuery?.data?.phonebook || [];
    const selectedPhonebookId = event?.data?.value?.api?.phonebookDetail || "";


    const FunnelNumberCol = ({ apiStrut }) => {
        function funnelNumberSet(values) {
            setNodes(nds => nds.map(node => {
                if (node.id == event.id) {
                    node.data.value.api.phone_number_col = values
                }
                return node;
            }))
            setRefecther(!refecther)
            setRefresher(!refresher)
        }

        console.log(apiStrut)
        return (
            <select className="form-select" onChange={(e) => funnelNumberSet(e.target.value)}>
                <option value="" disabled selected={!apiStrut.phone_number_col}>Select Phone Number Column</option>
                {apiStrut.Columns.map(x => (
                    <option key={`col_${x.column_name}`} value={`col_${x.column_name}`}
                        selected={apiStrut.phone_number_col == `col_${x.column_name}`}
                    >{x.column_name}</option>
                ))}
            </select>
        );
    }

    function FunnelSet(values) {
        setNodes(nds => nds.map(node => {
            if (node.id == event.id) {
                node.data.value.api.phonebookDetail = values
                node.data.value.api.Columns = phonebookQuery.data.column
                node.data.value.columns = [{
                    "column": phonebookQuery.data.column,
                    "type": "phonebook",
                    "details": { "phonebook_id": values }
                }]
            }
            return node;
        }))
        setRefecther(!refecther)
        setRefresher(!refresher)
    }

    return (
        <div className="card-body mt-0 ">
            <div className="contact_add_div">
                <div className="mx-auto">
                    {selectedPhonebookId && (<h6>{phonebookData.find(x => x.phonebook_id == selectedPhonebookId)?.phonebook_name} Phonebook is Set</h6>)}
                    <select
                        className="form-select" onChange={(e) => FunnelSet(e.target.value)}
                        defaultValue={selectedPhonebookId ? selectedPhonebookId : ""}
                    >
                        <option value="" disabled>Select Phonebook</option>
                        {phonebookData.map(x => (<option key={x.phonebook_id} value={x.phonebook_id}>{x.phonebook_name}</option>))}
                    </select>
                    {selectedPhonebookId && (<FunnelNumberCol apiStrut={event.data.value.api} />)}
                </div>
            </div>
        </div>
    )
}